import { useEffect } from 'react'
import { integrations } from '../data/integrations'

export function LiveSupportLoader() {
  useEffect(() => {
    if (!integrations.liveSupport.enabled) {
      return
    }

    let script: HTMLScriptElement | null = null
    let timeoutId = 0
    let idleId = 0

    const loadScript = () => {
      if (script) return

      script = document.createElement('script')
      script.async = true
      script.src = integrations.liveSupport.scriptUrl
      script.dataset.widgetId = integrations.liveSupport.widgetId
      script.dataset.markaId = integrations.liveSupport.brandId
      script.dataset.positionDesktop = integrations.liveSupport.desktopPosition
      script.dataset.positionMobile = integrations.liveSupport.mobilePosition
      script.dataset.primary = '#d1b366'
      script.dataset.secondary = '#111827'
      document.body.appendChild(script)
    }

    const scheduleLoad = () => {
      if ('requestIdleCallback' in window) {
        idleId = window.requestIdleCallback(loadScript, { timeout: 4500 })
        return
      }

      timeoutId = globalThis.setTimeout(loadScript, 2800)
    }

    window.addEventListener('pointerdown', loadScript, { once: true, passive: true })
    window.addEventListener('keydown', loadScript, { once: true })
    scheduleLoad()

    return () => {
      if (idleId && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId)
      }
      globalThis.clearTimeout(timeoutId)
      window.removeEventListener('pointerdown', loadScript)
      window.removeEventListener('keydown', loadScript)
      script?.remove()
    }
  }, [])

  return null
}
